/* ===========================================================
   Jaan Creations — full-screen product image viewer (13 Oct)
   Tap an image in the product gallery to open it full screen.
   Pinch or double-tap to zoom, drag to move around when zoomed,
   swipe left/right for the next image, swipe down (or tap the X,
   or press Back) to close. Works with mouse and keyboard too.
=========================================================== */
(function () {
  'use strict';

  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) { return; }

  var overlay = null, stage = null, imgEl = null, countEl = null;
  var closeBtn = null, prevBtn = null, nextBtn = null;
  var items = [];
  var index = 0;
  var scale = 1, tx = 0, ty = 0;
  var MAX_SCALE = 5;
  var pointers = {};
  var pointerCount = 0;
  var pinchStartDist = 1, pinchStartScale = 1;
  var panStart = null;
  var gestureStartX = 0, gestureStartY = 0;
  var gestureMoved = false, gesturePinched = false;
  var lastTapTime = 0, lastTapX = 0, lastTapY = 0;
  var lastFocus = null;
  var openState = false;
  var pushed = false;

  function collect() {
    items = [];
    var slides = gallery.querySelectorAll('[data-slide]');
    Array.prototype.forEach.call(slides, function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) { return; }
      items.push({ slide: i, src: img.getAttribute('src') || '', alt: img.getAttribute('alt') || '' });
    });
  }

  function bigSrc(src) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '1800');
      return u.toString();
    } catch (err) {
      return src;
    }
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'jc-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product images');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="jc-lb__stage"><img class="jc-lb__img" alt="" draggable="false"></div>' +
      '<button type="button" class="jc-lb__close" aria-label="Close">&times;</button>' +
      '<div class="jc-lb__count" aria-live="polite"></div>' +
      '<button type="button" class="jc-lb__nav jc-lb__prev" aria-label="Previous image">&lsaquo;</button>' +
      '<button type="button" class="jc-lb__nav jc-lb__next" aria-label="Next image">&rsaquo;</button>' +
      '<div class="jc-lb__hint">Pinch or double-tap to zoom</div>';
    document.body.appendChild(overlay);

    stage = overlay.querySelector('.jc-lb__stage');
    imgEl = overlay.querySelector('.jc-lb__img');
    countEl = overlay.querySelector('.jc-lb__count');
    closeBtn = overlay.querySelector('.jc-lb__close');
    prevBtn = overlay.querySelector('.jc-lb__prev');
    nextBtn = overlay.querySelector('.jc-lb__next');

    closeBtn.addEventListener('click', function () { closeViewer(false); });
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onCancel);
    stage.addEventListener('wheel', onWheel, { passive: false });
  }

  function apply(animate) {
    imgEl.style.transition = animate ? 'transform 0.2s ease' : 'none';
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
  }

  function clampPan() {
    var w = imgEl.clientWidth * scale;
    var h = imgEl.clientHeight * scale;
    var maxX = Math.max(0, (w - stage.clientWidth) / 2);
    var maxY = Math.max(0, (h - stage.clientHeight) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx));
    ty = Math.min(maxY, Math.max(-maxY, ty));
  }

  function zoomAt(newScale, cx, cy) {
    newScale = Math.min(MAX_SCALE, Math.max(1, newScale));
    var rect = stage.getBoundingClientRect();
    var ox = cx - rect.left - rect.width / 2;
    var oy = cy - rect.top - rect.height / 2;
    var ratio = newScale / scale;
    tx = ox - (ox - tx) * ratio;
    ty = oy - (oy - ty) * ratio;
    scale = newScale;
    if (scale === 1) { tx = 0; ty = 0; }
    clampPan();
  }

  function show(i) {
    scale = 1; tx = 0; ty = 0;
    apply(false);
    var item = items[i];
    imgEl.src = bigSrc(item.src);
    imgEl.alt = item.alt;
    countEl.textContent = (i + 1) + ' / ' + items.length;
    [i + 1, i - 1].forEach(function (n) {
      var nb = items[(n + items.length) % items.length];
      if (nb && nb !== item) { var pre = new Image(); pre.src = bigSrc(nb.src); }
    });
  }

  function go(step) {
    if (items.length < 2) { return; }
    index = (index + step + items.length) % items.length;
    show(index);
  }

  function twoPoints() {
    var ids = Object.keys(pointers);
    var a = pointers[ids[0]], b = pointers[ids[1]];
    return {
      dist: Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)),
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2
    };
  }

  function onDown(e) {
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    pointerCount = Object.keys(pointers).length;
    if (pointerCount === 1) {
      gestureStartX = e.clientX;
      gestureStartY = e.clientY;
      gestureMoved = false;
      gesturePinched = false;
      panStart = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
    } else if (pointerCount === 2) {
      gesturePinched = true;
      var p = twoPoints();
      pinchStartDist = p.dist || 1;
      pinchStartScale = scale;
    }
  }

  function onMove(e) {
    var p = pointers[e.pointerId];
    if (!p) { return; }
    p.x = e.clientX;
    p.y = e.clientY;
    if (pointerCount === 2) {
      var t = twoPoints();
      zoomAt(pinchStartScale * t.dist / pinchStartDist, t.x, t.y);
      apply(false);
      return;
    }
    if (pointerCount === 1) {
      var dx = e.clientX - gestureStartX;
      var dy = e.clientY - gestureStartY;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) { gestureMoved = true; }
      if (scale > 1 && panStart) {
        tx = panStart.tx + dx;
        ty = panStart.ty + dy;
        clampPan();
        apply(false);
      }
    }
  }

  function onUp(e) {
    if (!pointers[e.pointerId]) { return; }
    var upX = e.clientX, upY = e.clientY;
    delete pointers[e.pointerId];
    pointerCount = Object.keys(pointers).length;

    if (pointerCount === 1) {
      var rest = pointers[Object.keys(pointers)[0]];
      gestureStartX = rest.x;
      gestureStartY = rest.y;
      panStart = { x: rest.x, y: rest.y, tx: tx, ty: ty };
      return;
    }
    if (pointerCount > 0) { return; }

    if (gesturePinched) {
      gesturePinched = false;
      if (scale < 1.05) { scale = 1; tx = 0; ty = 0; apply(true); }
      return;
    }

    var dx = upX - gestureStartX;
    var dy = upY - gestureStartY;

    if (scale === 1 && gestureMoved) {
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? 1 : -1); return; }
      if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { closeViewer(false); return; }
      return;
    }

    if (!gestureMoved) {
      var now = Date.now();
      if (now - lastTapTime < 300 && Math.abs(upX - lastTapX) < 30 && Math.abs(upY - lastTapY) < 30) {
        lastTapTime = 0;
        zoomAt(scale > 1 ? 1 : 2.5, upX, upY);
        apply(true);
      } else {
        lastTapTime = now;
        lastTapX = upX;
        lastTapY = upY;
      }
    }
  }

  function onCancel(e) {
    delete pointers[e.pointerId];
    pointerCount = Object.keys(pointers).length;
    if (pointerCount === 0) { gesturePinched = false; }
  }

  function onWheel(e) {
    e.preventDefault();
    zoomAt(scale * (e.deltaY < 0 ? 1.2 : 1 / 1.2), e.clientX, e.clientY);
    apply(false);
  }

  function onKey(e) {
    if (e.key === 'Escape') { closeViewer(false); }
    else if (e.key === 'ArrowLeft') { go(-1); }
    else if (e.key === 'ArrowRight') { go(1); }
  }

  function openViewer(start) {
    if (!overlay) { build(); }
    lastFocus = document.activeElement;
    index = start;
    pointers = {};
    pointerCount = 0;
    var many = items.length > 1;
    prevBtn.style.display = many ? '' : 'none';
    nextBtn.style.display = many ? '' : 'none';
    countEl.style.display = many ? '' : 'none';
    overlay.hidden = false;
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('jc-lb-lock');
    show(index);
    document.addEventListener('keydown', onKey);
    openState = true;
    try { window.history.pushState({ jcLb: true }, ''); pushed = true; } catch (err) { pushed = false; }
    closeBtn.focus();
  }

  function closeViewer(fromPop) {
    if (!openState) { return; }
    openState = false;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('jc-lb-lock');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { if (!openState) { overlay.hidden = true; } }, 220);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (err) {} }
    if (pushed && !fromPop) {
      pushed = false;
      window.history.back();
    } else {
      pushed = false;
    }
  }

  window.addEventListener('popstate', function () {
    if (openState) { closeViewer(true); }
  });

  gallery.addEventListener('click', function (e) {
    var img = e.target && e.target.closest ? e.target.closest('[data-slide] img') : null;
    if (!img) { return; }
    var slide = img.closest('[data-slide]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
    var slideIndex = slides.indexOf(slide);
    collect();
    var start = 0;
    items.forEach(function (it, n) { if (it.slide === slideIndex) { start = n; } });
    if (!items.length) { return; }
    openViewer(start);
  });
})();
